import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum CheckDetailColumn {
    DATE = "date",
    CHECK_NUMBER = "checkNumber",
    REFERENCE = "reference",
    PAYEE = "payee",
    DESCRIPTION = "description",
    MEMO = "memo",
    ENTITY = "entity",
    CLASS = "class",
    ACCOUNT = "account",
    EXCLUDE_FROM_1099 = "excludeFrom1099",
    CLEARED_DATE = "clearedDate",
    RECONCILED = "reconciled",
    AMOUNT = "amount",
}

const DateColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.DATE),
});

const CheckNumberColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.CHECK_NUMBER),
});

const ReferenceColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.REFERENCE),
});

const PayeeColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.PAYEE),
});

const DescriptionColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.DESCRIPTION),
});

const MemoColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.MEMO),
});

const EntityColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.ENTITY),
});

const ClassColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.CLASS),
});

const AccountColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.ACCOUNT),
});

const ExcludeFrom1099ColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.EXCLUDE_FROM_1099),
});

const ClearedDateColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.CLEARED_DATE),
});

const ReconciledColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.RECONCILED),
});

const AmountColumnSchema = ColumnSchema.extend({
    id: z.literal(CheckDetailColumn.AMOUNT),
});

export const CheckDetailViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.CHECK_DETAIL),
    columns: z.array(
        z.discriminatedUnion("id", [
            DateColumnSchema,
            CheckNumberColumnSchema,
            ReferenceColumnSchema,
            PayeeColumnSchema,
            DescriptionColumnSchema,
            MemoColumnSchema,
            EntityColumnSchema,
            ClassColumnSchema,
            AccountColumnSchema,
            ExcludeFrom1099ColumnSchema,
            ClearedDateColumnSchema,
            ReconciledColumnSchema,
            AmountColumnSchema,
        ]),
    ),
});

export type CheckDetailView = z.infer<typeof CheckDetailViewSchema>;
